import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { BREAKPOINTS } from './breakpoints.js';

export function initAccountNavigation() {
  const navWrapper = document.querySelector('.account-navigation__swiper');
  const navList = navWrapper?.querySelector('.account-navigation__nav');

  if (!navWrapper || !navList) return;

  Array.from(navList.querySelectorAll('a')).forEach(a => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    a.replaceWith(slide);
    slide.appendChild(a);

    if (a.href === window.location.href) {
      a.classList.add('active');
    }
  });

  new Swiper(navWrapper, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    breakpoints: {
      [BREAKPOINTS.LARGE]: {
        slidesPerView: 3.2,
        allowTouchMove: false,
      },
    },
  });
}
